module.exports = __webpack_public_path__ + "static/media/communications-icon-selected.259835f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/communications-icon-selected.svg
// module id = 1926
// module chunks = 0